import React from "react";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <div className="mt-[100px] mb-[70px] md:mt-[150px] md:mb-[100px] container">
      <div className="grid sm:grid-cols-2 items-start gap-14 p-8 mx-auto max-w-7xl bg-white shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)] rounded-md font-[sans-serif]">
        <div>
          <h1 className="text-gray-800 text-3xl font-extrabold">دعونا نتحدث</h1>
          <p className="text-sm text-gray-500 mt-4">
            هل لديك فكرة كبيرة أو علامة تجارية ترغب في تطويرها وتحتاج إلى
            المساعدة؟ تواصل معنا، فنحن نحب أن نسمع عن مشروعك ونقدم المساعدة.
          </p>

          <div className="mt-12">
            <h2 className="text-gray-800 text-base font-bold">
              البريد الإلكتروني
            </h2>
            <ul className="mt-4">
              <li className="flex items-center">
                <div className="bg-[#e6e6e6cf] h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    height="20px"
                    fill="#007bff"
                    viewBox="0 0 479.058 479.058"
                  >
                    <path d="M434.146 59.882H44.912C20.146 59.882 0 80.028 0 104.794v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159L239.529 264.631 39.173 90.982a14.902 14.902 0 0 1 5.738-1.159zm0 299.411H44.912c-8.26 0-14.971-6.71-14.971-14.971V122.615l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z" />
                  </svg>
                </div>
                <a
                  href="mailto:damietta@zahrantravel.com"
                  className="text-[#007bff] text-sm mr-4"
                >
                  <small className="block">البريد</small>
                  <strong>damietta@zahrantravel.com</strong>
                </a>
              </li>
            </ul>
          </div>

          <div className="mt-12">
            <h2 className="text-gray-800 text-base font-bold">
              الوسائل الاجتماعية
            </h2>
            <ul className="flex mt-4 gap-4">
              <li className="bg-[#e6e6e6cf] h-10 w-10 rounded-full flex items-center justify-center">
                <a
                  href="https://wa.me/201222214924"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp size={20} color="#25D366" />
                </a>
              </li>
              <li className="bg-[#e6e6e6cf] h-10 w-10 rounded-full flex items-center justify-center">
                <a
                  href="https://www.facebook.com/share/1Aj9fMpVtM/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF size={20} color="#1877F2" />
                </a>
              </li>
              <li className="bg-[#e6e6e6cf] h-10 w-10 rounded-full flex items-center justify-center">
                <a
                  href="https://www.instagram.com/zahran_travel?igsh=MzB6dXZnMGlteDdh"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size={20} color="#E4405F" />
                </a>
              </li>
              <li className="bg-[#e6e6e6cf] h-10 w-10 rounded-full flex items-center justify-center">
                <a
                  href="https://www.tiktok.com/@zahran.travel?_t=ZS-8xVZJ0shDu4&_r=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok size={20} color="#000000" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <ContactForm />
      </div>
    </div>
  );
};

export default Contact;
